import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';
import AuthRoute from '../common/AuthRoute';
import RedeemRoute from './RedeemRoute';
import RedeemSuccess from './RedeemSuccess';

const PromoRoutes = () => {
  const { path } = useRouteMatch();
  const intl = useIntl();

  return (
    <Switch>
      <AuthRoute
        exact
        path={`${path}/redeem`}
        title={intl.formatMessage({
          id: 'redeem.seo.title',
          defaultMessage: 'ClearVPN | Redeem',
          description: 'SEO title of the page, where user can redeem free premium time promocodes',
        })}
      >
        <RedeemRoute />
      </AuthRoute>

      <AuthRoute
        exact
        path={`${path}/redeem/success`}
        title={intl.formatMessage({
          id: 'redeemSuccess.seo.title',
          defaultMessage: 'ClearVPN | Redeem success',
          description: 'SEO title of the page, where user is confirmed successful promo code application',
        })}
      >
        <RedeemSuccess />
      </AuthRoute>
    </Switch>
  );
};

export default PromoRoutes;
